module.exports = __webpack_public_path__ + "img/p20lite.70df6a04.jpg";